import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: any; output: any; }
  CustomData: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: any; output: any; }
  IntType: { input: any; output: any; }
  ItemId: { input: any; output: any; }
  JsonField: { input: any; output: any; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

export type BlogAuthorModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogAuthorModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogAuthorModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
};

export enum BlogAuthorModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC'
}

export type BlogPostModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogPostModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogPostModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  lead?: InputMaybe<TextFilter>;
  publishedAt?: InputMaybe<DateFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  tags?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum BlogPostModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  PublishedAt_ASC = 'publishedAt_ASC',
  PublishedAt_DESC = 'publishedAt_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter Date fields */
export type DateFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['Date']['input']>;
};

export type DeepDiveModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DeepDiveModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DeepDiveModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum DeepDiveModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

export type DefaultPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DefaultPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DefaultPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum DefaultPageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication'
}

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye'
}

export enum ImgixParamsBgRemoveFgType {
  Auto = 'auto',
  Car = 'car'
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit'
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width'
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Origin = 'origin',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial'
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale'
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v'
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp'
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block'
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsMarkTile {
  Grid = 'grid'
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json'
}

export enum ImgixParamsRotType {
  Pivot = 'pivot',
  Straighten = 'straighten'
}

export enum ImgixParamsTransparency {
  Grid = 'grid'
}

export enum ImgixParamsTrim {
  Alpha = 'alpha',
  Auto = 'auto',
  Color = 'color'
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export enum ImgixParamsTxtFit {
  Max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated'
}

export type JobDeepDiveModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<JobDeepDiveModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JobDeepDiveModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  applicationContact?: InputMaybe<StringFilter>;
  datePosted?: InputMaybe<DateFilter>;
  directApply?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  identifierName?: InputMaybe<StringFilter>;
  identifierValue?: InputMaybe<StringFilter>;
  immediateStart?: InputMaybe<BooleanFilter>;
  jobDescription?: InputMaybe<StructuredTextFilter>;
  jobEmploymentType?: InputMaybe<StringFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileFilter>;
  organizationName?: InputMaybe<StringFilter>;
  sameAs?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  tags?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
  validThrough?: InputMaybe<DateFilter>;
};

export enum JobDeepDiveModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  ApplicationContact_ASC = 'applicationContact_ASC',
  ApplicationContact_DESC = 'applicationContact_DESC',
  DatePosted_ASC = 'datePosted_ASC',
  DatePosted_DESC = 'datePosted_DESC',
  DirectApply_ASC = 'directApply_ASC',
  DirectApply_DESC = 'directApply_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  IdentifierName_ASC = 'identifierName_ASC',
  IdentifierName_DESC = 'identifierName_DESC',
  IdentifierValue_ASC = 'identifierValue_ASC',
  IdentifierValue_DESC = 'identifierValue_DESC',
  ImmediateStart_ASC = 'immediateStart_ASC',
  ImmediateStart_DESC = 'immediateStart_DESC',
  JobEmploymentType_ASC = 'jobEmploymentType_ASC',
  JobEmploymentType_DESC = 'jobEmploymentType_DESC',
  JobTitle_ASC = 'jobTitle_ASC',
  JobTitle_DESC = 'jobTitle_DESC',
  OrganizationName_ASC = 'organizationName_ASC',
  OrganizationName_DESC = 'organizationName_DESC',
  SameAs_ASC = 'sameAs_ASC',
  SameAs_DESC = 'sameAs_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  ValidThrough_ASC = 'validThrough_ASC',
  ValidThrough_DESC = 'validThrough_DESC'
}

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png'
}

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export type ProjectDeepDiveModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProjectDeepDiveModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProjectDeepDiveModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  seo?: InputMaybe<SeoFilter>;
  shortTitle?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  tags?: InputMaybe<LinksFilter>;
  teaser?: InputMaybe<FileFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum ProjectDeepDiveModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  ShortTitle_ASC = 'shortTitle_ASC',
  ShortTitle_DESC = 'shortTitle_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

export type ProjectShowcaseModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProjectShowcaseModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProjectShowcaseModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum ProjectShowcaseModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum SiteLocale {
  De = 'de',
  En = 'en'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TagModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TagModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TagModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
};

export enum TagModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC'
}

export type TeamMemberModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeamMemberModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeamMemberModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum TeamMemberModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Role_ASC = 'role_ASC',
  Role_DESC = 'role_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Basename_ASC = 'basename_ASC',
  Basename_DESC = 'basename_DESC',
  Filename_ASC = 'filename_ASC',
  Filename_DESC = 'filename_DESC',
  Format_ASC = 'format_ASC',
  Format_DESC = 'format_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MimeType_ASC = 'mimeType_ASC',
  MimeType_DESC = 'mimeType_DESC',
  Resolution_ASC = 'resolution_ASC',
  Resolution_DESC = 'resolution_DESC',
  Size_ASC = 'size_ASC',
  Size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type BlogPostFragment = { id: any, title?: string | null, lead?: string | null, publishedAt?: any | null, slug?: string | null, translatedSlug?: string | null, header?: { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, author?: { id: any, name?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null, tags: Array<{ id: any, name?: string | null }>, blogTeaser?: { __typename: 'BlogTeaserRecord', title?: string | null, image?: { url: string, alt?: string | null, mimeType: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null, content: Array<{ __typename: 'BlogMediumRecord', id: any, content?: { __typename: 'BlogDoubleImageRecord', id: any, leftDescription?: string | null, rightDescription?: string | null, leftImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, rightImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'BlogRichtextRecord', id: any, richtext?: { value: any, links: Array<{ __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null } | { __typename: 'BlogVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> };

export type BlogAuthorFragment = { id: any, name?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type BlogMediumFragment = { id: any, content?: { __typename: 'BlogDoubleImageRecord', id: any, leftDescription?: string | null, rightDescription?: string | null, leftImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, rightImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null };

export type BlogImageFragment = { id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type BlogDoubleImageFragment = { id: any, leftDescription?: string | null, rightDescription?: string | null, leftImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, rightImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type BlogRichtextFragment = { id: any, richtext?: { value: any, links: Array<{ __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null };

export type BlogVideoFragment = { id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

type HeaderModulesPage_Header3dRecord_Fragment = { __typename: 'Header3dRecord', id: any, titleLine1?: string | null, titleLine2?: string | null, eyebrow?: string | null };

type HeaderModulesPage_HeaderBlogRecord_Fragment = { __typename: 'HeaderBlogRecord', id: any, title?: string | null };

type HeaderModulesPage_HeaderDefaultRecord_Fragment = { __typename: 'HeaderDefaultRecord', id: any, title?: string | null, eyebrow?: string | null };

export type HeaderModulesPageFragment = HeaderModulesPage_Header3dRecord_Fragment | HeaderModulesPage_HeaderBlogRecord_Fragment | HeaderModulesPage_HeaderDefaultRecord_Fragment;

export type HeaderDefaultFragment = { __typename: 'HeaderDefaultRecord', id: any, title?: string | null, eyebrow?: string | null };

export type HeaderBlogFragment = { __typename: 'HeaderBlogRecord', id: any, title?: string | null };

export type Header3dFragment = { __typename: 'Header3dRecord', id: any, titleLine1?: string | null, titleLine2?: string | null, eyebrow?: string | null };

export type DefaultPageLinkFragment = { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null };

export type DeepDiveLinkFragment = { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null };

export type JobDeepDiveLinkFragment = { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null };

export type ProjectDeepDiveLinkFragment = { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null };

export type BlogPostLinkFragment = { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null };

type ModulesProject_ContentCtaRecord_Fragment = { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

type ModulesProject_DeepDiveAssetRecord_Fragment = { __typename: 'DeepDiveAssetRecord', id: any, imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

type ModulesProject_DeepDiveTeamRecord_Fragment = { __typename: 'DeepDiveTeamRecord', id: any, people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type ModulesProject_DeepDiveTextRecord_Fragment = { __typename: 'DeepDiveTextRecord', id: any, gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null };

type ModulesProject_RichtextCtaRecord_Fragment = {};

export type ModulesProjectFragment = ModulesProject_ContentCtaRecord_Fragment | ModulesProject_DeepDiveAssetRecord_Fragment | ModulesProject_DeepDiveTeamRecord_Fragment | ModulesProject_DeepDiveTextRecord_Fragment | ModulesProject_RichtextCtaRecord_Fragment;

type ModulesDeepDive_ContentCtaRecord_Fragment = { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

type ModulesDeepDive_DeepDiveAssetRecord_Fragment = { __typename: 'DeepDiveAssetRecord', id: any, imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

type ModulesDeepDive_DeepDiveTeamRecord_Fragment = { __typename: 'DeepDiveTeamRecord', id: any, people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type ModulesDeepDive_DeepDiveTextRecord_Fragment = { __typename: 'DeepDiveTextRecord', id: any, gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null };

export type ModulesDeepDiveFragment = ModulesDeepDive_ContentCtaRecord_Fragment | ModulesDeepDive_DeepDiveAssetRecord_Fragment | ModulesDeepDive_DeepDiveTeamRecord_Fragment | ModulesDeepDive_DeepDiveTextRecord_Fragment;

type ModulesJob_ContentCtaRecord_Fragment = { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

type ModulesJob_DeepDiveAssetRecord_Fragment = { __typename: 'DeepDiveAssetRecord', id: any, imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

type ModulesJob_DeepDiveTeamRecord_Fragment = { __typename: 'DeepDiveTeamRecord', id: any, people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type ModulesJob_DeepDiveTextRecord_Fragment = { __typename: 'DeepDiveTextRecord', id: any, gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null };

type ModulesJob_RichtextCtaRecord_Fragment = {};

export type ModulesJobFragment = ModulesJob_ContentCtaRecord_Fragment | ModulesJob_DeepDiveAssetRecord_Fragment | ModulesJob_DeepDiveTeamRecord_Fragment | ModulesJob_DeepDiveTextRecord_Fragment | ModulesJob_RichtextCtaRecord_Fragment;

type Modules_ContentBenefitRecord_Fragment = { __typename: 'ContentBenefitRecord', id: any, title?: string | null, benefits: Array<{ title?: string | null, description?: { value: any } | null }> };

type Modules_ContentCtaRecord_Fragment = { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

type Modules_ContentFigureRecord_Fragment = { __typename: 'ContentFigureRecord', id: any, title?: string | null, figures: Array<{ figure?: string | null, description?: string | null }> };

type Modules_ContentImageMultipleRecord_Fragment = { __typename: 'ContentImageMultipleRecord', id: any, title?: string | null, images: Array<{ cropping?: string | null, showInCard: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type Modules_ContentImageRecord_Fragment = { __typename: 'ContentImageRecord', id: any, cropping?: string | null, showInCard: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

type Modules_ContentLogowallRecord_Fragment = { __typename: 'ContentLogowallRecord', id: any, title?: string | null, logos: Array<{ id: any, url: string, alt?: string | null }> };

type Modules_ContentRichtextRecord_Fragment = { __typename: 'ContentRichtextRecord', id: any, gradient?: string | null, richtext?: { value: any } | null };

type Modules_ContentShowreelRecord_Fragment = { __typename: 'ContentShowreelRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

type Modules_ContentTeamsliderRecord_Fragment = { __typename: 'ContentTeamsliderRecord', id: any, title?: string | null, teamMembers: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type Modules_ContentTestimonialRecord_Fragment = { __typename: 'ContentTestimonialRecord', id: any, testimonials: Array<{ id: any, name?: string | null, statement?: string | null, role?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, logo?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type Modules_ContentTextRecord_Fragment = { __typename: 'ContentTextRecord', id: any, gradient?: string | null, text?: { value: any } | null };

type Modules_ContentVideoRecord_Fragment = { __typename: 'ContentVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

type Modules_GridonicWayQuicklaunchRecord_Fragment = {};

type Modules_GridonicWayRecord_Fragment = { __typename: 'GridonicWayRecord', id: any, theGridonicWay?: { id: any, title?: string | null, items: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | null };

type Modules_ProjectsBigRecord_Fragment = { __typename: 'ProjectsBigRecord', id: any, projects: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, shortTitle?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, assetRight?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, assetLeft?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null }> };

type Modules_ProjectsSimpleRecord_Fragment = { __typename: 'ProjectsSimpleRecord', id: any, title?: string | null, clickable: any, projects: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type Modules_ProjectsTeaserRecord_Fragment = { __typename: 'ProjectsTeaserRecord', id: any, title?: string | null, clickable: any, projects: Array<{ __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'ProjectShowcaseRecord', id: any, title?: string | null, asset?: { __typename: 'TeaserImageRecord', id: any, cropping?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'TeaserVideoRecord', id: any, videoType?: string | null, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> };

type Modules_TeaserTeamRecord_Fragment = { __typename: 'TeaserTeamRecord', id: any, video?: { videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

export type ModulesFragment = Modules_ContentBenefitRecord_Fragment | Modules_ContentCtaRecord_Fragment | Modules_ContentFigureRecord_Fragment | Modules_ContentImageMultipleRecord_Fragment | Modules_ContentImageRecord_Fragment | Modules_ContentLogowallRecord_Fragment | Modules_ContentRichtextRecord_Fragment | Modules_ContentShowreelRecord_Fragment | Modules_ContentTeamsliderRecord_Fragment | Modules_ContentTestimonialRecord_Fragment | Modules_ContentTextRecord_Fragment | Modules_ContentVideoRecord_Fragment | Modules_GridonicWayQuicklaunchRecord_Fragment | Modules_GridonicWayRecord_Fragment | Modules_ProjectsBigRecord_Fragment | Modules_ProjectsSimpleRecord_Fragment | Modules_ProjectsTeaserRecord_Fragment | Modules_TeaserTeamRecord_Fragment;

export type ContentTextFragment = { gradient?: string | null, text?: { value: any } | null };

export type ContentRichtextFragment = { gradient?: string | null, richtext?: { value: any } | null };

export type ContentTestimonialFragment = { testimonials: Array<{ id: any, name?: string | null, statement?: string | null, role?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, logo?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type ContentTeamSliderFragment = { title?: string | null, teamMembers: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type ContentImageFragment = { cropping?: string | null, showInCard: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ContentImagesMultipleFragment = { title?: string | null, images: Array<{ cropping?: string | null, showInCard: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type ContentFigureFragment = { title?: string | null, figures: Array<{ figure?: string | null, description?: string | null }> };

export type HomeProjectFragment = { featuredProjects: Array<{ __typename: 'ProjectDeepDiveRecord', id: any }> };

export type ProjectsSimpleFragment = { title?: string | null, clickable: any, projects: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type ProjectsTeaserFragment = { title?: string | null, clickable: any, projects: Array<{ __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'ProjectShowcaseRecord', id: any, title?: string | null, asset?: { __typename: 'TeaserImageRecord', id: any, cropping?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'TeaserVideoRecord', id: any, videoType?: string | null, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> };

export type ProjectsBigFragment = { projects: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, shortTitle?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, assetRight?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, assetLeft?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null }> };

export type TeaserTeamFragment = { video?: { videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

export type ContentVideoFragment = { videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

export type ContentShowreelFragment = { videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

export type ContentCtaFragment = { title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type ContentLogowallFragment = { title?: string | null, logos: Array<{ id: any, url: string, alt?: string | null }> };

export type ContentBenefitsFragment = { title?: string | null, benefits: Array<{ title?: string | null, description?: { value: any } | null }> };

export type DeepDiveTextFragment = { gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null };

export type DeepDiveTeamFragment = { people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type DeepDiveAssetFragment = { imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

export type PageMetaFragment = { id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> };

export type TestimonialFragment = { id: any, name?: string | null, statement?: string | null, role?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, logo?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ItemFragment = { title?: string | null, content?: { value: any } | null };

export type BenefitFragment = { title?: string | null, description?: { value: any } | null };

export type TeaserItemFragment = { title?: string | null, text?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type JobLocationFragment = { streetAddress?: string | null, addressCountry?: string | null, postalCode?: string | null, addressLocality?: string | null };

export type FooterAddressFragment = { title?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, color?: string | null, mapLink?: string | null };

export type FigureElementFragment = { figure?: string | null, description?: string | null };

export type GridonicWayFragment = { theGridonicWay?: { id: any, title?: string | null, items: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | null };

export type TheGridonicWayFragment = { title?: string | null, items: Array<{ id: any, title?: string | null, content?: { value: any } | null }> };

export type AssetFragment = { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

export type LinkFragment = { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null };

export type IconLinkFragment = { id: any, title?: string | null, link?: string | null, icon?: string | null, showOnMobile: any, svg?: { id: any, url: string, alt?: string | null } | null };

export type NavLinkFragment = { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type NavContentFragment = { id: any, title?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null };

export type ProjectTeaserFragment = { id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ProjectTeaserWorkFragment = { id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, shortTitle?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ProjectTeaserHomeFragment = { id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, shortTitle?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, assetRight?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, assetLeft?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null };

export type ProjectShowcaseFragment = { __typename: 'ProjectShowcaseRecord', id: any, title?: string | null, asset?: { __typename: 'TeaserImageRecord', id: any, cropping?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'TeaserVideoRecord', id: any, videoType?: string | null, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type TeaserImageFragment = { cropping?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type TeaserVideoFragment = { id: any, videoType?: string | null, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null };

export type ResponsiveImageFragment = { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string };

export type RichtextCtaFragment = { id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type TeamMemberFragment = { __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type GetAllBlogPostsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAllBlogPostsQuery = { allBlogPosts: Array<{ id: any, title?: string | null, lead?: string | null, publishedAt?: any | null, slug?: string | null, translatedSlug?: string | null, header?: { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, author?: { id: any, name?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null, tags: Array<{ id: any, name?: string | null }>, blogTeaser?: { __typename: 'BlogTeaserRecord', title?: string | null, image?: { url: string, alt?: string | null, mimeType: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null, content: Array<{ __typename: 'BlogMediumRecord', id: any, content?: { __typename: 'BlogDoubleImageRecord', id: any, leftDescription?: string | null, rightDescription?: string | null, leftImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, rightImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'BlogRichtextRecord', id: any, richtext?: { value: any, links: Array<{ __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null } | { __typename: 'BlogVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> }> };

export type GetAllProjectsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAllProjectsQuery = { allProjectDeepDives: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, shortTitle?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type GetBlogPostByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetBlogPostByTranslatedSlugQuery = { blogPost?: { id: any, title?: string | null, lead?: string | null, publishedAt?: any | null, slug?: string | null, translatedSlug?: string | null, header?: { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, author?: { id: any, name?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null, tags: Array<{ id: any, name?: string | null }>, blogTeaser?: { __typename: 'BlogTeaserRecord', title?: string | null, image?: { url: string, alt?: string | null, mimeType: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null, content: Array<{ __typename: 'BlogMediumRecord', id: any, content?: { __typename: 'BlogDoubleImageRecord', id: any, leftDescription?: string | null, rightDescription?: string | null, leftImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, rightImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'BlogImageRecord', id: any, description?: string | null, fullWidth: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'BlogRichtextRecord', id: any, richtext?: { value: any, links: Array<{ __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null } | { __typename: 'BlogVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null };

export type GetControlPanelQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetControlPanelQuery = { controlPanel?: { id: any, mainNavigation: Array<{ __typename: 'NavContentRecord', id: any, title?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null } | { __typename: 'NavLinkRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }>, footerNavigation: Array<{ __typename: 'NavContentRecord', id: any, title?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null } | { __typename: 'NavLinkRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }>, socialMediaLinks: Array<{ id: any, title?: string | null, link?: string | null, icon?: string | null, showOnMobile: any, svg?: { id: any, url: string, alt?: string | null } | null }> } | null };

type MainNavigation_NavContentRecord_Fragment = { __typename: 'NavContentRecord', id: any, title?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null };

type MainNavigation_NavLinkRecord_Fragment = { __typename: 'NavLinkRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type MainNavigationFragment = MainNavigation_NavContentRecord_Fragment | MainNavigation_NavLinkRecord_Fragment;

type FooterNavigation_NavContentRecord_Fragment = { __typename: 'NavContentRecord', id: any, title?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> } | null };

type FooterNavigation_NavLinkRecord_Fragment = { __typename: 'NavLinkRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null };

export type FooterNavigationFragment = FooterNavigation_NavContentRecord_Fragment | FooterNavigation_NavLinkRecord_Fragment;

export type GetDeepDiveByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetDeepDiveByTranslatedSlugQuery = { deepDive?: { id: any, title?: string | null, slug?: string | null, translatedSlug?: string | null, contentModules: Array<{ __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | { __typename: 'DeepDiveAssetRecord', id: any, imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null } | { __typename: 'DeepDiveTeamRecord', id: any, people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'DeepDiveTextRecord', id: any, gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null }>, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type GetJobByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetJobByTranslatedSlugQuery = { jobDeepDive?: { id: any, title?: string | null, slug?: string | null, translatedSlug?: string | null, datePosted?: any | null, directApply: any, identifierName?: string | null, identifierValue?: string | null, immediateStart: any, jobEmploymentType?: string | null, jobTitle?: string | null, organizationName?: string | null, sameAs?: string | null, validThrough?: any | null, applicationContact?: string | null, contentModules: Array<{ __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | { __typename: 'DeepDiveAssetRecord', id: any, imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null } | { __typename: 'DeepDiveTeamRecord', id: any, people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'DeepDiveTextRecord', id: any, gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null } | {}>, tags: Array<{ id: any, name?: string | null }>, jobLocation: Array<{ addressCountry?: string | null, addressLocality?: string | null, streetAddress?: string | null, postalCode?: string | null, id: any }>, jobDescription?: { value: any } | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type GetPageByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetPageByTranslatedSlugQuery = { defaultPage?: { id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, headerModule?: { __typename: 'Header3dRecord', id: any, titleLine1?: string | null, titleLine2?: string | null, eyebrow?: string | null } | { __typename: 'HeaderBlogRecord', id: any, title?: string | null } | { __typename: 'HeaderDefaultRecord', id: any, title?: string | null, eyebrow?: string | null } | null, contentModules: Array<{ __typename: 'ContentBenefitRecord', id: any, title?: string | null, benefits: Array<{ title?: string | null, description?: { value: any } | null }> } | { __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | { __typename: 'ContentFigureRecord', id: any, title?: string | null, figures: Array<{ figure?: string | null, description?: string | null }> } | { __typename: 'ContentImageMultipleRecord', id: any, title?: string | null, images: Array<{ cropping?: string | null, showInCard: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'ContentImageRecord', id: any, cropping?: string | null, showInCard: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'ContentLogowallRecord', id: any, title?: string | null, logos: Array<{ id: any, url: string, alt?: string | null }> } | { __typename: 'ContentRichtextRecord', id: any, gradient?: string | null, richtext?: { value: any } | null } | { __typename: 'ContentShowreelRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | { __typename: 'ContentTeamsliderRecord', id: any, title?: string | null, teamMembers: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'ContentTestimonialRecord', id: any, testimonials: Array<{ id: any, name?: string | null, statement?: string | null, role?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, logo?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'ContentTextRecord', id: any, gradient?: string | null, text?: { value: any } | null } | { __typename: 'ContentVideoRecord', id: any, videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | { __typename: 'GridonicWayRecord', id: any, theGridonicWay?: { id: any, title?: string | null, items: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | null } | { __typename: 'ProjectsBigRecord', id: any, projects: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, shortTitle?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, assetRight?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, assetLeft?: { id: any, cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null }> } | { __typename: 'ProjectsSimpleRecord', id: any, title?: string | null, clickable: any, projects: Array<{ id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'ProjectsTeaserRecord', id: any, title?: string | null, clickable: any, projects: Array<{ __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'ProjectShowcaseRecord', id: any, title?: string | null, asset?: { __typename: 'TeaserImageRecord', id: any, cropping?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'TeaserVideoRecord', id: any, videoType?: string | null, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | { __typename: 'TeaserTeamRecord', id: any, video?: { videoType?: string | null, videoAutoplay: any, videoCaption?: string | null, videoControls: any, videoLoop: any, videoEmbedded?: { provider: string } | null, videoCustom?: { url: string, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null } | {}>, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type GetProjectByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetProjectByTranslatedSlugQuery = { projectDeepDive?: { id: any, title?: string | null, shortTitle?: string | null, slug?: string | null, translatedSlug?: string | null, contentModules: Array<{ __typename: 'ContentCtaRecord', id: any, title?: string | null, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | { __typename: 'DeepDiveAssetRecord', id: any, imageStyle?: string | null, asset?: { cropping?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_slim?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_square?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null, asset_wide?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { mp4Url?: string | null, thumbnailUrl: string } | null } | null } | null } | { __typename: 'DeepDiveTeamRecord', id: any, people: Array<{ __typename: 'TeamMemberRecord', id: any, role?: string | null, name?: string | null, image?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, image_3_4?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'DeepDiveTextRecord', id: any, gradient?: string | null, alignment?: string | null, textStyle?: string | null, text?: { value: any, links: Array<{ __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }>, blocks: Array<{ __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null }> } | null, cta?: { __typename: 'RichtextCtaRecord', id: any, gradient?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'BlogPostRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'DefaultPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'JobDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | { __typename: 'ProjectDeepDiveRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null } | null } | null } | null } | {}>, tags: Array<{ id: any, name?: string | null }>, teaser?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type GetSiteInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteInfoQuery = { siteInfo?: { id: any, addressSet: Array<{ __typename: 'FooterAddressRecord', id: any, title?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, color?: string | null, mapLink?: string | null }> } | null };

export type AddressSetFragment = { __typename: 'FooterAddressRecord', id: any, title?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, color?: string | null, mapLink?: string | null };

export type SiteInfoFragment = { id: any, addressSet: Array<{ __typename: 'FooterAddressRecord', id: any, title?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, color?: string | null, mapLink?: string | null }> };

export type GetTheGridonicWayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTheGridonicWayQuery = { theGridonicWay?: { __typename: 'TheGridonicWayRecord', title?: string | null, items: Array<{ __typename: 'ItemRecord', id: any, title?: string | null, content?: { value: any } | null }> } | null };

export type GetTranslatedSlugsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetTranslatedSlugsQuery = { allDeepDives: Array<{ slug?: string | null, translatedSlug?: string | null, title?: string | null, _allTranslatedSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> };

export type GetTranslationPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranslationPanelQuery = { translationPanel?: { acceptAll?: string | null, back?: string | null, id: any, continue?: string | null, openCloseNavigation?: string | null, required?: string | null, saveSelection?: string | null, settings?: string | null, youAreHere?: string | null, toPageEnd?: string | null, toMainNavigation?: string | null, toMainContent?: string | null, toHomePage?: string | null } | null };

export type TranslationPanelFragment = { acceptAll?: string | null, back?: string | null, id: any, continue?: string | null, openCloseNavigation?: string | null, required?: string | null, saveSelection?: string | null, settings?: string | null, youAreHere?: string | null, toPageEnd?: string | null, toMainNavigation?: string | null, toMainContent?: string | null, toHomePage?: string | null };

export const ResponsiveImageFragmentDoc = gql`
    fragment ResponsiveImage on ResponsiveImage {
  src
  width
  height
  alt
  title
  base64
  bgColor
  sizes
}
    `;
export const BlogImageFragmentDoc = gql`
    fragment BlogImage on BlogImageRecord {
  id
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  description
  fullWidth
}
    `;
export const BlogVideoFragmentDoc = gql`
    fragment BlogVideo on BlogVideoRecord {
  id
  videoType
  videoAutoplay
  videoCaption
  videoControls
  videoLoop
  videoEmbedded {
    provider
  }
  videoCustom {
    url
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
}
    `;
export const BlogAuthorFragmentDoc = gql`
    fragment BlogAuthor on BlogAuthorRecord {
  id
  name
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
}
    `;
export const BlogDoubleImageFragmentDoc = gql`
    fragment BlogDoubleImage on BlogDoubleImageRecord {
  id
  leftImage {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  leftDescription
  rightImage {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  rightDescription
}
    `;
export const BlogMediumFragmentDoc = gql`
    fragment BlogMedium on BlogMediumRecord {
  id
  content {
    ... on BlogImageRecord {
      id
      __typename
      ...BlogImage
    }
    ... on BlogDoubleImageRecord {
      id
      __typename
      ...BlogDoubleImage
    }
  }
}
    `;
export const DefaultPageLinkFragmentDoc = gql`
    fragment DefaultPageLink on DefaultPageRecord {
  __typename
  id
  slug
  title
  translatedSlug
  _allTranslatedSlugLocales {
    locale
    value
  }
}
    `;
export const BlogPostLinkFragmentDoc = gql`
    fragment BlogPostLink on BlogPostRecord {
  __typename
  id
  slug
  title
  translatedSlug
  _allTranslatedSlugLocales {
    locale
    value
  }
}
    `;
export const DeepDiveLinkFragmentDoc = gql`
    fragment DeepDiveLink on DeepDiveRecord {
  __typename
  id
  slug
  title
  translatedSlug
  _allTranslatedSlugLocales {
    locale
    value
  }
}
    `;
export const BlogRichtextFragmentDoc = gql`
    fragment BlogRichtext on BlogRichtextRecord {
  id
  richtext {
    value
    links {
      __typename
      ...DefaultPageLink
      ...BlogPostLink
      ...DeepDiveLink
    }
  }
}
    `;
export const JobDeepDiveLinkFragmentDoc = gql`
    fragment JobDeepDiveLink on JobDeepDiveRecord {
  __typename
  id
  slug
  title
  translatedSlug
  _allTranslatedSlugLocales {
    locale
    value
  }
}
    `;
export const ProjectDeepDiveLinkFragmentDoc = gql`
    fragment ProjectDeepDiveLink on ProjectDeepDiveRecord {
  __typename
  id
  slug
  title
  translatedSlug
  _allTranslatedSlugLocales {
    locale
    value
  }
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on LinkRecord {
  emailUrl
  externalUrl
  id
  linkText
  linkType
  openLinkInNewWindow
  internalUrl {
    __typename
    ...DefaultPageLink
    ...DeepDiveLink
    ...JobDeepDiveLink
    ...ProjectDeepDiveLink
    ...BlogPostLink
  }
}
    `;
export const ContentCtaFragmentDoc = gql`
    fragment ContentCta on ContentCtaRecord {
  title
  link {
    ...Link
  }
  gradient
}
    `;
export const BlogPostFragmentDoc = gql`
    fragment BlogPost on BlogPostRecord {
  id
  title
  lead
  header {
    __typename
    ... on BlogImageRecord {
      id
      __typename
      ...BlogImage
    }
    ... on BlogVideoRecord {
      id
      __typename
      ...BlogVideo
    }
  }
  publishedAt
  slug
  translatedSlug
  author {
    ...BlogAuthor
  }
  tags {
    id
    name
  }
  blogTeaser {
    title
    __typename
    image {
      url
      alt
      mimeType
      video {
        mp4Url(res: high)
        thumbnailUrl
      }
      responsiveImage {
        ...ResponsiveImage
      }
    }
  }
  content {
    ... on BlogMediumRecord {
      id
      __typename
      ...BlogMedium
    }
    ... on BlogRichtextRecord {
      id
      __typename
      ...BlogRichtext
    }
    ... on BlogVideoRecord {
      id
      __typename
      ...BlogVideo
    }
    ... on ContentCtaRecord {
      id
      __typename
      ...ContentCta
    }
  }
}
    `;
export const HeaderDefaultFragmentDoc = gql`
    fragment HeaderDefault on HeaderDefaultRecord {
  id
  __typename
  title
  eyebrow
}
    `;
export const HeaderBlogFragmentDoc = gql`
    fragment HeaderBlog on HeaderBlogRecord {
  id
  __typename
  title
}
    `;
export const Header3dFragmentDoc = gql`
    fragment Header3d on Header3dRecord {
  id
  __typename
  titleLine1
  titleLine2
  eyebrow
}
    `;
export const HeaderModulesPageFragmentDoc = gql`
    fragment HeaderModulesPage on DefaultPageModelHeaderModuleField {
  ...HeaderDefault
  ...HeaderBlog
  ...Header3d
}
    `;
export const RichtextCtaFragmentDoc = gql`
    fragment RichtextCta on RichtextCtaRecord {
  id
  link {
    ...Link
  }
  gradient
}
    `;
export const DeepDiveTextFragmentDoc = gql`
    fragment DeepDiveText on DeepDiveTextRecord {
  text {
    value
    links {
      __typename
      ...DefaultPageLink
      ...DeepDiveLink
      ...JobDeepDiveLink
      ...ProjectDeepDiveLink
    }
    blocks {
      __typename
      ...RichtextCta
    }
  }
  gradient
  alignment
  textStyle
  cta {
    __typename
    ...RichtextCta
  }
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on TeamMemberRecord {
  __typename
  id
  role
  name
  image {
    id
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  image_3_4: image {
    id
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "3:4", fit: crop, auto: format}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const DeepDiveTeamFragmentDoc = gql`
    fragment DeepDiveTeam on DeepDiveTeamRecord {
  people {
    ...TeamMember
  }
}
    `;
export const AssetFragmentDoc = gql`
    fragment Asset on AssetRecord {
  asset {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
  asset_slim: asset {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "12:16", fit: crop, auto: format}) {
      ...ResponsiveImage
    }
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
  asset_square: asset {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "1:1", fit: crop, auto: format}) {
      ...ResponsiveImage
    }
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
  asset_wide: asset {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "16:12", fit: crop, auto: format}) {
      ...ResponsiveImage
    }
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
  cropping
}
    `;
export const DeepDiveAssetFragmentDoc = gql`
    fragment DeepDiveAsset on DeepDiveAssetRecord {
  asset {
    ...Asset
  }
  imageStyle
}
    `;
export const ModulesProjectFragmentDoc = gql`
    fragment ModulesProject on ProjectDeepDiveModelContentModulesField {
  ... on DeepDiveTextRecord {
    id
    __typename
    ...DeepDiveText
  }
  ... on DeepDiveTeamRecord {
    id
    __typename
    ...DeepDiveTeam
  }
  ... on DeepDiveAssetRecord {
    id
    __typename
    ...DeepDiveAsset
  }
  ... on ContentCtaRecord {
    id
    __typename
    ...ContentCta
  }
}
    `;
export const ModulesDeepDiveFragmentDoc = gql`
    fragment ModulesDeepDive on DeepDiveModelContentModulesField {
  ... on DeepDiveTextRecord {
    id
    __typename
    ...DeepDiveText
  }
  ... on DeepDiveTeamRecord {
    id
    __typename
    ...DeepDiveTeam
  }
  ... on DeepDiveAssetRecord {
    id
    __typename
    ...DeepDiveAsset
  }
  ... on ContentCtaRecord {
    id
    __typename
    ...ContentCta
  }
}
    `;
export const ModulesJobFragmentDoc = gql`
    fragment ModulesJob on JobDeepDiveModelContentModulesField {
  ... on DeepDiveTextRecord {
    id
    __typename
    ...DeepDiveText
  }
  ... on DeepDiveTeamRecord {
    id
    __typename
    ...DeepDiveTeam
  }
  ... on DeepDiveAssetRecord {
    id
    __typename
    ...DeepDiveAsset
  }
  ... on ContentCtaRecord {
    id
    __typename
    ...ContentCta
  }
}
    `;
export const ContentTextFragmentDoc = gql`
    fragment ContentText on ContentTextRecord {
  text {
    value
  }
  gradient
}
    `;
export const ContentRichtextFragmentDoc = gql`
    fragment ContentRichtext on ContentRichtextRecord {
  richtext {
    value
  }
  gradient
}
    `;
export const TestimonialFragmentDoc = gql`
    fragment Testimonial on TestimonialRecord {
  id
  name
  statement
  role
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  logo {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
}
    `;
export const ContentTestimonialFragmentDoc = gql`
    fragment ContentTestimonial on ContentTestimonialRecord {
  testimonials {
    ...Testimonial
  }
}
    `;
export const ContentVideoFragmentDoc = gql`
    fragment ContentVideo on ContentVideoRecord {
  videoType
  videoAutoplay
  videoCaption
  videoControls
  videoLoop
  videoEmbedded {
    provider
  }
  videoCustom {
    url
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
}
    `;
export const TeaserTeamFragmentDoc = gql`
    fragment TeaserTeam on TeaserTeamRecord {
  video {
    ...ContentVideo
  }
}
    `;
export const FigureElementFragmentDoc = gql`
    fragment FigureElement on FigureElementRecord {
  figure
  description
}
    `;
export const ContentFigureFragmentDoc = gql`
    fragment ContentFigure on ContentFigureRecord {
  title
  figures {
    ...FigureElement
  }
}
    `;
export const BenefitFragmentDoc = gql`
    fragment Benefit on BenefitRecord {
  title
  description {
    value
  }
}
    `;
export const ContentBenefitsFragmentDoc = gql`
    fragment ContentBenefits on ContentBenefitRecord {
  title
  benefits {
    ...Benefit
  }
}
    `;
export const ItemFragmentDoc = gql`
    fragment Item on ItemRecord {
  title
  content {
    value
  }
}
    `;
export const TheGridonicWayFragmentDoc = gql`
    fragment TheGridonicWay on TheGridonicWayRecord {
  title
  items {
    id
    ...Item
  }
}
    `;
export const GridonicWayFragmentDoc = gql`
    fragment GridonicWay on GridonicWayRecord {
  theGridonicWay {
    id
    ...TheGridonicWay
  }
}
    `;
export const ContentImageFragmentDoc = gql`
    fragment ContentImage on ContentImageRecord {
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  cropping
  showInCard
}
    `;
export const ContentTeamSliderFragmentDoc = gql`
    fragment ContentTeamSlider on ContentTeamsliderRecord {
  title
  teamMembers {
    ...TeamMember
  }
}
    `;
export const ContentShowreelFragmentDoc = gql`
    fragment ContentShowreel on ContentShowreelRecord {
  videoType
  videoAutoplay
  videoCaption
  videoControls
  videoLoop
  videoEmbedded {
    provider
  }
  videoCustom {
    url
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
}
    `;
export const ContentImagesMultipleFragmentDoc = gql`
    fragment ContentImagesMultiple on ContentImageMultipleRecord {
  title
  images {
    ...ContentImage
  }
}
    `;
export const ContentLogowallFragmentDoc = gql`
    fragment ContentLogowall on ContentLogowallRecord {
  title
  logos {
    id
    url
    alt
  }
}
    `;
export const ProjectTeaserHomeFragmentDoc = gql`
    fragment ProjectTeaserHome on ProjectDeepDiveRecord {
  id
  slug
  translatedSlug
  title
  shortTitle
  _allTranslatedSlugLocales {
    locale
    value
  }
  assetRight {
    id
    ...Asset
  }
  assetLeft {
    id
    ...Asset
  }
}
    `;
export const ProjectsBigFragmentDoc = gql`
    fragment ProjectsBig on ProjectsBigRecord {
  projects {
    id
    ...ProjectTeaserHome
  }
}
    `;
export const ProjectTeaserFragmentDoc = gql`
    fragment ProjectTeaser on ProjectDeepDiveRecord {
  id
  slug
  translatedSlug
  _allTranslatedSlugLocales {
    locale
    value
  }
  title
  teaser {
    id
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "12:16", fit: crop, auto: format}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const ProjectsSimpleFragmentDoc = gql`
    fragment ProjectsSimple on ProjectsSimpleRecord {
  title
  clickable
  projects {
    ...ProjectTeaser
  }
}
    `;
export const TeaserImageFragmentDoc = gql`
    fragment TeaserImage on TeaserImageRecord {
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  cropping
}
    `;
export const TeaserVideoFragmentDoc = gql`
    fragment TeaserVideo on TeaserVideoRecord {
  id
  videoType
  videoEmbedded {
    provider
  }
  videoCustom {
    url
    video {
      mp4Url(res: high)
      thumbnailUrl
    }
  }
}
    `;
export const ProjectShowcaseFragmentDoc = gql`
    fragment ProjectShowcase on ProjectShowcaseRecord {
  __typename
  id
  title
  asset {
    ... on TeaserImageRecord {
      id
      __typename
      ...TeaserImage
    }
    ... on TeaserVideoRecord {
      id
      __typename
      ...TeaserVideo
    }
  }
  link {
    ...Link
  }
}
    `;
export const ProjectsTeaserFragmentDoc = gql`
    fragment ProjectsTeaser on ProjectsTeaserRecord {
  title
  clickable
  projects {
    __typename
    ...ProjectShowcase
    ...ProjectTeaser
  }
}
    `;
export const ModulesFragmentDoc = gql`
    fragment Modules on DefaultPageModelContentModulesField {
  ... on ContentTextRecord {
    id
    __typename
    ...ContentText
  }
  ... on ContentRichtextRecord {
    id
    __typename
    ...ContentRichtext
  }
  ... on ContentTestimonialRecord {
    id
    __typename
    ...ContentTestimonial
  }
  ... on TeaserTeamRecord {
    id
    __typename
    ...TeaserTeam
  }
  ... on ContentFigureRecord {
    id
    __typename
    ...ContentFigure
  }
  ... on ContentBenefitRecord {
    id
    __typename
    ...ContentBenefits
  }
  ... on GridonicWayRecord {
    id
    __typename
    ...GridonicWay
  }
  ... on ContentImageRecord {
    id
    __typename
    ...ContentImage
  }
  ... on ContentTeamsliderRecord {
    id
    __typename
    ...ContentTeamSlider
  }
  ... on ContentVideoRecord {
    id
    __typename
    ...ContentVideo
  }
  ... on ContentShowreelRecord {
    id
    __typename
    ...ContentShowreel
  }
  ... on ContentImageMultipleRecord {
    id
    __typename
    ...ContentImagesMultiple
  }
  ... on ContentCtaRecord {
    id
    __typename
    ...ContentCta
  }
  ... on ContentLogowallRecord {
    id
    __typename
    ...ContentLogowall
  }
  ... on ProjectsBigRecord {
    id
    __typename
    ...ProjectsBig
  }
  ... on ProjectsSimpleRecord {
    id
    __typename
    ...ProjectsSimple
  }
  ... on ProjectsTeaserRecord {
    id
    __typename
    ...ProjectsTeaser
  }
}
    `;
export const HomeProjectFragmentDoc = gql`
    fragment HomeProject on HomeProjectRecord {
  featuredProjects {
    id
    __typename
  }
}
    `;
export const PageMetaFragmentDoc = gql`
    fragment PageMeta on DefaultPageRecord {
  id
  slug
  title
  translatedSlug
  _seoMetaTags {
    attributes
    content
    tag
  }
}
    `;
export const TeaserItemFragmentDoc = gql`
    fragment TeaserItem on TeaserItemRecord {
  title
  text {
    value
  }
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  link {
    ...Link
  }
}
    `;
export const JobLocationFragmentDoc = gql`
    fragment JobLocation on JobLocationRecord {
  streetAddress
  addressCountry
  postalCode
  addressLocality
}
    `;
export const FooterAddressFragmentDoc = gql`
    fragment FooterAddress on FooterAddressRecord {
  title
  street
  zipCode
  city
  color
  mapLink
}
    `;
export const IconLinkFragmentDoc = gql`
    fragment IconLink on IconLinkRecord {
  id
  title
  link
  icon
  showOnMobile
  svg {
    id
    url
    alt
  }
}
    `;
export const ProjectTeaserWorkFragmentDoc = gql`
    fragment ProjectTeaserWork on ProjectDeepDiveRecord {
  id
  slug
  translatedSlug
  title
  shortTitle
  _allTranslatedSlugLocales {
    locale
    value
  }
  teaser {
    id
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "12:16", fit: crop, auto: format}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const NavLinkFragmentDoc = gql`
    fragment NavLink on NavLinkRecord {
  id
  link {
    ...Link
  }
}
    `;
export const NavContentFragmentDoc = gql`
    fragment NavContent on NavContentRecord {
  id
  title
  text {
    value
    links {
      __typename
      ...DefaultPageLink
      ...DeepDiveLink
      ...JobDeepDiveLink
      ...ProjectDeepDiveLink
    }
  }
}
    `;
export const MainNavigationFragmentDoc = gql`
    fragment MainNavigation on ControlPanelModelMainNavigationField {
  __typename
  ...NavLink
  ...NavContent
}
    `;
export const FooterNavigationFragmentDoc = gql`
    fragment FooterNavigation on ControlPanelModelFooterNavigationField {
  __typename
  ...NavLink
  ...NavContent
}
    `;
export const AddressSetFragmentDoc = gql`
    fragment AddressSet on FooterAddressRecord {
  __typename
  id
  title
  street
  zipCode
  city
  color
  mapLink
}
    `;
export const SiteInfoFragmentDoc = gql`
    fragment SiteInfo on SiteInfoRecord {
  id
  addressSet {
    ...AddressSet
  }
}
    `;
export const TranslationPanelFragmentDoc = gql`
    fragment TranslationPanel on TranslationPanelRecord {
  acceptAll
  back
  id
  continue
  openCloseNavigation
  required
  saveSelection
  settings
  youAreHere
  toPageEnd
  toMainNavigation
  toMainContent
  toHomePage
}
    `;
export const GetAllBlogPostsDocument = gql`
    query GetAllBlogPosts($locale: SiteLocale) {
  allBlogPosts(first: "100", locale: $locale) {
    ...BlogPost
  }
}
    ${BlogPostFragmentDoc}
${BlogImageFragmentDoc}
${ResponsiveImageFragmentDoc}
${BlogVideoFragmentDoc}
${BlogAuthorFragmentDoc}
${BlogMediumFragmentDoc}
${BlogDoubleImageFragmentDoc}
${BlogRichtextFragmentDoc}
${DefaultPageLinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${ContentCtaFragmentDoc}
${LinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}`;
export const GetAllProjectsDocument = gql`
    query GetAllProjects($locale: SiteLocale) {
  allProjectDeepDives(first: "100", locale: $locale) {
    ...ProjectTeaserWork
  }
}
    ${ProjectTeaserWorkFragmentDoc}
${ResponsiveImageFragmentDoc}`;
export const GetBlogPostByTranslatedSlugDocument = gql`
    query GetBlogPostByTranslatedSlug($slug: String, $locale: SiteLocale) {
  blogPost(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    ...BlogPost
  }
}
    ${BlogPostFragmentDoc}
${BlogImageFragmentDoc}
${ResponsiveImageFragmentDoc}
${BlogVideoFragmentDoc}
${BlogAuthorFragmentDoc}
${BlogMediumFragmentDoc}
${BlogDoubleImageFragmentDoc}
${BlogRichtextFragmentDoc}
${DefaultPageLinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${ContentCtaFragmentDoc}
${LinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}`;
export const GetControlPanelDocument = gql`
    query GetControlPanel($locale: SiteLocale) {
  controlPanel(locale: $locale) {
    id
    mainNavigation {
      ...MainNavigation
    }
    footerNavigation {
      ...FooterNavigation
    }
    socialMediaLinks {
      ...IconLink
    }
  }
}
    ${MainNavigationFragmentDoc}
${NavLinkFragmentDoc}
${LinkFragmentDoc}
${DefaultPageLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${NavContentFragmentDoc}
${FooterNavigationFragmentDoc}
${IconLinkFragmentDoc}`;
export const GetDeepDiveByTranslatedSlugDocument = gql`
    query GetDeepDiveByTranslatedSlug($slug: String, $locale: SiteLocale) {
  deepDive(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    id
    title
    slug
    translatedSlug
    contentModules {
      ...ModulesDeepDive
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ModulesDeepDiveFragmentDoc}
${DeepDiveTextFragmentDoc}
${DefaultPageLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}
${RichtextCtaFragmentDoc}
${LinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${DeepDiveTeamFragmentDoc}
${TeamMemberFragmentDoc}
${ResponsiveImageFragmentDoc}
${DeepDiveAssetFragmentDoc}
${AssetFragmentDoc}
${ContentCtaFragmentDoc}`;
export const GetJobByTranslatedSlugDocument = gql`
    query GetJobByTranslatedSlug($slug: String, $locale: SiteLocale) {
  jobDeepDive(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    id
    title
    slug
    translatedSlug
    contentModules {
      ...ModulesJob
    }
    tags {
      id
      name
    }
    datePosted
    directApply
    identifierName
    identifierValue
    immediateStart
    jobEmploymentType
    jobLocation {
      addressCountry
      addressLocality
      streetAddress
      postalCode
      id
    }
    jobTitle
    organizationName
    sameAs
    validThrough
    applicationContact
    jobDescription {
      value
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ModulesJobFragmentDoc}
${DeepDiveTextFragmentDoc}
${DefaultPageLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}
${RichtextCtaFragmentDoc}
${LinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${DeepDiveTeamFragmentDoc}
${TeamMemberFragmentDoc}
${ResponsiveImageFragmentDoc}
${DeepDiveAssetFragmentDoc}
${AssetFragmentDoc}
${ContentCtaFragmentDoc}`;
export const GetPageByTranslatedSlugDocument = gql`
    query GetPageByTranslatedSlug($slug: String, $locale: SiteLocale) {
  defaultPage(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    ...PageMeta
    headerModule {
      ...HeaderModulesPage
    }
    contentModules {
      ...Modules
    }
  }
}
    ${PageMetaFragmentDoc}
${HeaderModulesPageFragmentDoc}
${HeaderDefaultFragmentDoc}
${HeaderBlogFragmentDoc}
${Header3dFragmentDoc}
${ModulesFragmentDoc}
${ContentTextFragmentDoc}
${ContentRichtextFragmentDoc}
${ContentTestimonialFragmentDoc}
${TestimonialFragmentDoc}
${ResponsiveImageFragmentDoc}
${TeaserTeamFragmentDoc}
${ContentVideoFragmentDoc}
${ContentFigureFragmentDoc}
${FigureElementFragmentDoc}
${ContentBenefitsFragmentDoc}
${BenefitFragmentDoc}
${GridonicWayFragmentDoc}
${TheGridonicWayFragmentDoc}
${ItemFragmentDoc}
${ContentImageFragmentDoc}
${ContentTeamSliderFragmentDoc}
${TeamMemberFragmentDoc}
${ContentShowreelFragmentDoc}
${ContentImagesMultipleFragmentDoc}
${ContentCtaFragmentDoc}
${LinkFragmentDoc}
${DefaultPageLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${ContentLogowallFragmentDoc}
${ProjectsBigFragmentDoc}
${ProjectTeaserHomeFragmentDoc}
${AssetFragmentDoc}
${ProjectsSimpleFragmentDoc}
${ProjectTeaserFragmentDoc}
${ProjectsTeaserFragmentDoc}
${ProjectShowcaseFragmentDoc}
${TeaserImageFragmentDoc}
${TeaserVideoFragmentDoc}`;
export const GetProjectByTranslatedSlugDocument = gql`
    query GetProjectByTranslatedSlug($slug: String, $locale: SiteLocale) {
  projectDeepDive(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    id
    title
    shortTitle
    slug
    translatedSlug
    contentModules {
      ...ModulesProject
    }
    tags {
      id
      name
    }
    teaser {
      id
      url
      alt
      mimeType
      responsiveImage(imgixParams: {ar: "12:16", fit: crop, auto: format}) {
        ...ResponsiveImage
      }
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ModulesProjectFragmentDoc}
${DeepDiveTextFragmentDoc}
${DefaultPageLinkFragmentDoc}
${DeepDiveLinkFragmentDoc}
${JobDeepDiveLinkFragmentDoc}
${ProjectDeepDiveLinkFragmentDoc}
${RichtextCtaFragmentDoc}
${LinkFragmentDoc}
${BlogPostLinkFragmentDoc}
${DeepDiveTeamFragmentDoc}
${TeamMemberFragmentDoc}
${ResponsiveImageFragmentDoc}
${DeepDiveAssetFragmentDoc}
${AssetFragmentDoc}
${ContentCtaFragmentDoc}`;
export const GetSiteInfoDocument = gql`
    query GetSiteInfo {
  siteInfo {
    ...SiteInfo
  }
}
    ${SiteInfoFragmentDoc}
${AddressSetFragmentDoc}`;
export const GetTheGridonicWayDocument = gql`
    query GetTheGridonicWay {
  theGridonicWay {
    __typename
    title
    items {
      id
      __typename
      ...Item
    }
  }
}
    ${ItemFragmentDoc}`;
export const GetTranslatedSlugsDocument = gql`
    query GetTranslatedSlugs($locale: SiteLocale) {
  allDeepDives(locale: $locale) {
    slug
    translatedSlug
    title
    _allTranslatedSlugLocales {
      locale
      value
    }
  }
}
    `;
export const GetTranslationPanelDocument = gql`
    query GetTranslationPanel {
  translationPanel {
    ...TranslationPanel
  }
}
    ${TranslationPanelFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetAllBlogPosts(variables?: GetAllBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllBlogPostsQuery>(GetAllBlogPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAllBlogPosts', 'query', variables);
    },
    GetAllProjects(variables?: GetAllProjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllProjectsQuery>(GetAllProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAllProjects', 'query', variables);
    },
    GetBlogPostByTranslatedSlug(variables?: GetBlogPostByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBlogPostByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostByTranslatedSlugQuery>(GetBlogPostByTranslatedSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBlogPostByTranslatedSlug', 'query', variables);
    },
    GetControlPanel(variables?: GetControlPanelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetControlPanelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetControlPanelQuery>(GetControlPanelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetControlPanel', 'query', variables);
    },
    GetDeepDiveByTranslatedSlug(variables?: GetDeepDiveByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDeepDiveByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDeepDiveByTranslatedSlugQuery>(GetDeepDiveByTranslatedSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDeepDiveByTranslatedSlug', 'query', variables);
    },
    GetJobByTranslatedSlug(variables?: GetJobByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobByTranslatedSlugQuery>(GetJobByTranslatedSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetJobByTranslatedSlug', 'query', variables);
    },
    GetPageByTranslatedSlug(variables?: GetPageByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageByTranslatedSlugQuery>(GetPageByTranslatedSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageByTranslatedSlug', 'query', variables);
    },
    GetProjectByTranslatedSlug(variables?: GetProjectByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProjectByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectByTranslatedSlugQuery>(GetProjectByTranslatedSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProjectByTranslatedSlug', 'query', variables);
    },
    GetSiteInfo(variables?: GetSiteInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSiteInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSiteInfoQuery>(GetSiteInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSiteInfo', 'query', variables);
    },
    GetTheGridonicWay(variables?: GetTheGridonicWayQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTheGridonicWayQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTheGridonicWayQuery>(GetTheGridonicWayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTheGridonicWay', 'query', variables);
    },
    GetTranslatedSlugs(variables?: GetTranslatedSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTranslatedSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTranslatedSlugsQuery>(GetTranslatedSlugsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTranslatedSlugs', 'query', variables);
    },
    GetTranslationPanel(variables?: GetTranslationPanelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTranslationPanelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTranslationPanelQuery>(GetTranslationPanelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTranslationPanel', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;